// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_Fsf","cls2":"ReportList-cls2_eHM ReportList-cls1_Fsf"};